module.exports = __webpack_public_path__ + "static/media/kerning.8387ae75.svg";